import React from 'react'
import { Select } from 'antd'
import type { WidgetProps } from '@rjsf/utils'

export function ConfigurationSelectWidget({
  id,
  value,
  disabled,
  readonly,
  autofocus,
  onChange,
  onBlur,
  onFocus,
  options,
  placeholder,
}: WidgetProps) {
  const { enumOptions, enumDisabled, emptyValue } = options

  if (!Array.isArray(enumOptions) || enumOptions.length === 0) {
    return null
  }

  const selectOptions = enumOptions.map(
    ({ value: optionValue, label }, index) => ({
      value: index,
      label,
      disabled:
        Array.isArray(enumDisabled) && enumDisabled.includes(optionValue),
    })
  )

  const selectedIndex = enumOptions.findIndex(
    (option) => option.value === value
  )

  const handleChange = (nextIndex: number) => {
    const selectedOption = enumOptions[nextIndex]
    if (selectedOption === undefined) {
      onChange(emptyValue)
      return
    }

    // Use explicit null — `null ?? emptyValue` would incorrectly become undefined.
    onChange(selectedOption.value)
  }

  return (
    <Select
      id={id}
      autoFocus={autofocus}
      disabled={disabled || readonly}
      getPopupContainer={() => document.body}
      showSearch={false}
      style={{ width: '100%' }}
      placeholder={placeholder}
      value={selectedIndex >= 0 ? selectedIndex : undefined}
      options={selectOptions}
      onChange={handleChange}
      onBlur={() => onBlur(id, value)}
      onFocus={() => onFocus(id, value)}
    />
  )
}
